export enum PermissionSubject {
  All = '*'
}
